export default "__VITE_ASSET__f1de07f8__"